import { getAppConfig } from '@client/core/config/get-app-config';
import { ltrim } from '@client/core/utils/ltrim';

/**
 * This config will append the application Base URI to any path passed in.
 * The Base URI indicates if the application is available from within a
 * subdirectory in off the root domain such as "www.domain.com/dir-name-here".
 *
 * This will remove the leading slash if present.
 *
 * @example uri('project/id/estimator')
 */
export function uri(path: string): string {
  const { baseUri } = getAppConfig();

  return `${baseUri}/${ltrim(path, '/')}`;
}
